import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {bulkAssignMutation, BulkAssignTicketsInput} from './__generated__/bulkAssignMutation.graphql';

const mutation = graphql`
	mutation bulkAssignMutation($input: BulkAssignTicketsInput!) {
		bulkAssignTickets(input: $input) {
			clientMutationId
			updated {
				id
				assigneeId
				assignee {
					id
					...ticketingPerson_person
				}
			}
			failed
		}
	}
`;

function commit(
	environment: Environment,
	input: BulkAssignTicketsInput,
	onCompleted?: (r: bulkAssignMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<bulkAssignMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'bulkAssignMutation'};
